export default {
  blockPrices: [],
  priceCategories: [],
  tmpBooking: null
}
